module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/chevron-down-under-2a605d1005a10e288cd982d62777e057.svg";